const depositDefaults = {
  deposit_easybank: {
    meta: {
      funds: null,
      startDate: '',
      endDate: '',
      accountNumber: '',
      bankLogo: '',
    },
    id: '',
    category: 'deposit_easybank',
    status: 'new',
    amount: null,
  },

  other_deposit_account: {
    meta: {
      funds: null,
      accountNumber: '',
      bank: '',
      bankLogo: '',
    },
    id: '',
    category: 'other_deposit_account',
    status: 'new',
    amount: null,
  },

  deposit_guarantee: {
    meta: {
      startDate: '',
      endDate: '',
      policyNumber: '',
      supplier: 'Södeberg & Partners',
      bankLogo: 'https://www.soderbergpartners.no/Assets/Icons/logo_new.svg',
    },
    id: '',
    category: 'deposit_guarantee',
    status: 'new',
    amount: null,
  },

  other_deposit_guarantee: {
    meta: {
      startDate: '',
      endDate: '',
      policyNumber: '',
      supplier: '',
    },
    id: '',
    category: 'other_deposit_guarantee',
    status: 'new',
    amount: null,
  },

  bank_guarantee: {
    meta: {
      startDate: '',
      endDate: '',
      bank: '',
      policyNumber: '',
    },
    id: '',
    category: 'bank_guarantee',
    status: 'new',
    amount: null,
  },

  nav_guarantee: {
    meta: {
      startDate: '',
      endDate: '',
      policyNumber: '',
      NAVOffice: '',
      NAVContactPerson: '',
      NAVEmail: '',
      NAVPhone: '',
    },
    id: '',
    category: 'nav_guarantee',
    status: 'new',
    amount: null,
  },

  other: {
    meta: {
      startDate: '',
      endDate: '',
      funds: 1000,
      otherSecurityType: '',
    },
    id: '',
    category: 'other',
    status: 'new',
    amount: null,
  },
};

export default {
  depositDefaults,
};
